import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './index';

// Typed once here so no component has to annotate a dispatch or a selector.
// Plain `useDispatch` loses the thunk overload, which is how you end up with an
// `unknown` action type at every call site.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
